<router-outlet></router-outlet>

@if (loadingService.global(); as fs) {
  <gr-loader variant="fullscreen" size="xl" [label]="fs.label" />
}

<gr-toast />
